import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { IVideoCallMember } from '../../interfaces/IVideoCallMember';

@Component({
  selector: 'ngx-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VideoComponent {
  @Input() member: IVideoCallMember;
  @Input() members: number;

  ngAfterViewInit() {
    this.setVideo();
  }

  setVideo(): void {
    this.member.video = true;
    this.member.containerVideo = document.getElementById(this.member.agoraUid) as HTMLElement | null;
    if (this.member.remoteVideoPlayer && this.member.containerVideo) {
      this.member.remoteVideoPlayer.play(this.member.containerVideo);
    }
  }
}
